export const ROOT = '/';
export const QUESTIONS_ROUTE = '/questions';
export const RESULTS_ROUTE = '/results';
